import { render, staticRenderFns } from "./OpenEmailBrowser.vue?vue&type=template&id=5b19095c"
import script from "./OpenEmailBrowser.vue?vue&type=script&lang=js"
export * from "./OpenEmailBrowser.vue?vue&type=script&lang=js"
import style0 from "./OpenEmailBrowser.vue?vue&type=style&index=0&id=5b19095c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports